import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_google_sign_in = _resolveComponent("ontos-google-sign-in")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ontos_auth_layout = _resolveComponent("ontos-auth-layout")!
  const _component_ontos_ask_dialog = _resolveComponent("ontos-ask-dialog")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, {
    flush: "",
    ref: "base"
  }), {
    default: _withCtx(() => [
      _createVNode(_component_ontos_auth_layout, {
        title: _ctx.$tt('signup-title'),
        subtitle: _ctx.$tt('signup-subtitle')
      }, {
        social: _withCtx(() => [
          _createVNode(_component_ontos_google_sign_in, {
            onSigned: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enter())),
            onFailed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onGoogleFailed($event)))
          })
        ]),
        foot: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$tt('have-account-message')), 1),
          _createVNode(_component_router_link, {
            class: "plain-link ms-1",
            to: {name: 'login'}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tt('login')), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.signup()), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.name,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
                  _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorMessages.name = ''))
                ],
                label: _ctx.$tt('name'),
                autocomplete: "name",
                "error-messages": _ctx.errorMessages.name
              }, null, 8, ["modelValue", "label", "error-messages"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                  _cache[5] || (_cache[5] = ($event: any) => (_ctx.errorMessages.email = ''))
                ],
                label: _ctx.$tt('email'),
                type: "email",
                autocomplete: "email",
                class: "mt-2",
                "error-messages": _ctx.errorMessages.email
              }, null, 8, ["modelValue", "label", "error-messages"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.password,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((_ctx.password) = $event)),
                  _cache[7] || (_cache[7] = ($event: any) => (_ctx.errorMessages.password = ''))
                ],
                label: _ctx.$tt('password'),
                type: "password",
                autocomplete: "new-password",
                class: "mt-2",
                "error-messages": _ctx.errorMessages.password
              }, null, 8, ["modelValue", "label", "error-messages"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.confirmPassword,
                "onUpdate:modelValue": [
                  _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                  _cache[9] || (_cache[9] = ($event: any) => (_ctx.errorMessages.confirmPassword = ''))
                ],
                label: _ctx.$tt('password-confirm'),
                type: "password",
                autocomplete: "new-password",
                class: "mt-2",
                "error-messages": _ctx.errorMessages.confirmPassword
              }, null, 8, ["modelValue", "label", "error-messages"]),
              _createVNode(_component_v_btn, {
                type: "submit",
                block: "",
                color: "primary",
                size: "large",
                class: "mt-6",
                loading: _ctx.isSaving
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$tt('signup')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "subtitle"]),
      (_ctx.created)
        ? (_openBlock(), _createBlock(_component_ontos_ask_dialog, {
            key: 0,
            title: _ctx.$tt('auth.account-created-title'),
            message: _ctx.$tt('auth.account-created-message'),
            actions: _ctx.createdActions,
            onPick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toLogin())),
            onClosed: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toLogin()))
          }, null, 8, ["title", "message", "actions"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}